import React from 'react'

function resolvePrintSrc(src?: string) {
  if (!src) return "";
  if (/^https?:\/\//i.test(src) || src.startsWith("data:")) return src;
  if (src.includes("/uploads/images")) {
    return `${process.env.REACT_APP_API ?? ""}${src}`;
  }
  return src;
}

function LetterHead({item,src}:any) {
  const imageSrc = resolvePrintSrc(src);
  const isDataImage = imageSrc.startsWith("data:");
  return (
    <img
    style={{
      position: "absolute",
      top: item?.top,
      left: item?.left,
      height: item?.height,
      width: item?.width,
      display: item?.show ? "" : "none",
    }}
     {...(!isDataImage && imageSrc ? { crossOrigin: "anonymous" } : {})}
    src={imageSrc}
    alt=""
  />
  )
}

export default LetterHead